import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Home';
import MMluBenchmarkDisplay from './MMluBenchmarkDisplay';
import ASI1VoiceDocumentation from './ASI1VoiceDocumentation';
import ASI1Extended from './ASI1Extended';
import ASI1Mini from './ASI1Mini';
import ASI1Fast from './ASI1Fast';
import ASIGraph from './ASIGraph';
import ASI1FinanceExpertAgent from './ASI1FinanceExpertAgent';
import Status from './Status';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import DynamicAgenticSystem from './DynamicAgenticSystem';
import Monitor from './Monitor';
import MonitorHistoryPage from './MonitorHistoryPage';
import Login from './Login';
import RequireAuth from './components/RequireAuth';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Routes>
          {/* Status page without container padding for full-screen embed */}
          <Route path="/status" element={<Status />} />
          <Route
            path="/monitor"
            element={
              <RequireAuth>
                <div className="container mx-auto p-4 pt-6"><Monitor /></div>
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/model-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="mini" title="ASI1 - Mini History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/extended-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="extended" title="ASI1 - Extended History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/fast-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="fast" title="ASI1 - Fast History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/image-engine-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="imagex" title="ASI1 - Image Engine History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/vision-engine-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="vision" title="ASI1 - Vision Engine History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/graph-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="graph" title="ASI1 - Graph History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/web-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="web" title="Web Search History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/structured-output-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="structured" title="ASI1 - Structured Output History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/tool-calling-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="tools" title="Tool Calling History" />
              </RequireAuth>
            }
          />
          <Route
            path="/monitor/streaming-history"
            element={
              <RequireAuth>
                <MonitorHistoryPage type="model" variant="streaming" title="Streaming History" />
              </RequireAuth>
            }
          />
          <Route path="/login" element={<Login />} />
          
          {/* All other routes with container padding */}
          <Route path="/" element={<div className="container mx-auto p-4 pt-6"><Home /></div>} />
          <Route path="/home" element={<div className="container mx-auto p-4 pt-6"><Home /></div>} />
          <Route path="/benchmarks" element={<div className="container mx-auto p-4 pt-6"><MMluBenchmarkDisplay /></div>} />
          <Route path="/voice-model" element={<div className="container mx-auto p-4 pt-6"><ASI1VoiceDocumentation /></div>} />
          <Route path="/mini-model" element={<div className="container mx-auto p-4 pt-6"><ASI1Mini /></div>} />
          <Route path="/fast-model" element={<div className="container mx-auto p-4 pt-6"><ASI1Fast /></div>} />
          <Route path="/graph-model" element={<div className="container mx-auto p-4 pt-6"><ASIGraph /></div>} />
          <Route path="/extended-model" element={<div className="container mx-auto p-4 pt-6"><ASI1Extended /></div>} />
          <Route path="/finance-expert-agent" element={<div className="container mx-auto p-4 pt-6"><ASI1FinanceExpertAgent /></div>} />
          <Route path="/dynamic-agentic-system" element={<div className="container mx-auto p-4 pt-6"><DynamicAgenticSystem /></div>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
